import classNames from "classnames";
import React from "react";
import { Icon } from "../icon";
import { TransparentButton } from "../transparent-button";

import "./photo-source.css";

export const PhotoSource = ({
	name,
	storeType,
	partnerLogoSvgUrl,
	isConnected,
	connectedText,
	disabled,
	onClick,
}: {
	disabled?: boolean;
	onClick: () => void;
	connectedText?: string;
	name: string;
	partnerLogoSvgUrl?: string;
	isConnected?: boolean;
	storeType: eXpress.core.StoreType;
}) => {
	return (
		<TransparentButton
			className={classNames("photo-source", {
				"photo-source--disabled": disabled,
			})}
			onClick={onClick}
		>
			{storeType === eXpress.core.StoreType.Local ? (
				<Icon className="photo-source__icon" iconName="device" />
			) : (
				// eslint-disable-next-line jsx-a11y/alt-text
				<img className="partner-image" src={partnerLogoSvgUrl} />
			)}

			<div className="photo-source__name">{name}</div>

			{!!isConnected && !!connectedText && (
				<div className="photo-source__connected-as">
					<p
						// Do we need to allow HTML in CMS for this label?

						dangerouslySetInnerHTML={{
							__html: connectedText,
						}}
					/>
				</div>
			)}
		</TransparentButton>
	);
};
